/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Drawer, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveBarangayReservationType, onClose, isEdit, selectedReservationType } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			let params = Object.assign({}, values, { barangay_uid })
			if (isEdit && selectedReservationType) {
				params = Object.assign({}, params, { reservation_type_uid: selectedReservationType.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_brgy_reservation', content: 'Saving facility, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBarangayReservationType(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_reservation', content: 'Facility successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay reservation type')
					message.error({ key: 'set_brgy_reservation', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedReservationType } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title="Add Facility"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Name of facility'>
							{ getFieldDecorator('name', {
								initialValue: (selectedReservationType) ? selectedReservationType.name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Reservation Name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Description'>
							{ getFieldDecorator('description', {
								initialValue: (selectedReservationType) ? selectedReservationType.description : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Description'/>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_RESERVATION_TYPE = gql`
    mutation setBarangayReservationType($input: JSON) {
		setBarangayReservationType(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-reservation-type' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_RESERVATION_TYPE, {
		props({ mutate }) {
			return {
				saveBarangayReservationType(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayReservationTypes']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
